export const STORY_TYPES = {
  IN_THE_NEWS: 'In The News',
  AWARDS: 'Awards & Recognition',
  PRESS_RELEASE: 'Press Releases',
}
